import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom"
import style from './pricingCard.module.scss';
import EditDropDown from "../../Dropdown/EditDropDown/DropDown"
import EditInput from "../../EditInput/input"
import SwitchButton from "../../SelectionControls/Switch/Switch"
import RangeSlider from "../../pricing/rangeSlider/rangeSlider"
import Skeleton from "../../skeleton/skeleton"
import toPersianNumber from "../../../helpers/actions/toPersianNumber"
import toEnglishNumber from "../../../helpers/actions/toEnglishNumber"
import { numberWithCommas } from "../../../helpers/actions/splitNumberWithComma";
import { ErrorCodes } from "../../../helpers/consts/pricingConsts"
import { getManyVariant } from "../../../actions/APIcalls"
import moment from 'moment-jalaali'


const PricingCard = (props) => {
    const [moreInfo, setMoreInfo] = useState(false)
    const [isEdited, setIsEdited] = useState(false)
    const [moreTips, setMoreTips] = useState(false)
    const [isUpdating, setIsUpdating] = useState(false)

    useEffect(() => {
        if (isEdited) {
            props.isEditing('add')
        } else {
            props.isEditing('remove')
        }
    }, [isEdited]);

    const nameRef = useRef(null);
    ///lifeCycles**********************************
    useEffect(() => {
        let tmp = editInfo
        tmp.selectedPricingLabel.name = convertDropDownValue(editInfo.selectedPricingLabel.value)
        setEditInfo({ ...tmp })
        // Validator()
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.data])

    //functions********************************************************

    const backgroundColor = () => {
        if (!props.data.robot.salesStatus) {
            return 'wrapperGrey'
        } else {
            if (props.data.errorText) {
                return 'wrapperRed'
            } else {
                return props.data.inByBox ? 'wrapperGreen' : 'wrapperYellow'
            }
        }
    }

    const toggleActiveRobot = (e, value, tag) => {
        if (tag == 'isRobotActive') {
            let tmp = editInfo
            tmp.isRobotActive = !tmp.isRobotActive
            setEditInfo({ ...tmp })
            // call to change
            editFunction('activeRobot')
        }
    }

    const handleEditInfo = (tag, item) => {
        let tmp = editInfo
        if (tag == 'selectedPricingLabel') {
            tmp[tag] = item
        } else {
            tmp[tag] = toEnglishNumber(item.target.value.replaceAll(',', ''))
        }
        setEditInfo({ ...tmp })
        setIsEdited(true)
    }

    const deleteAll = () => {
        let tmp = editInfo
        tmp.selectedPricingLabel = null
        setEditInfo({ ...tmp })
    }

    const resetAllEditInfo = () => {
        let tmp = editInfo
        tmp = {
            isRobotActive: props.data.robot.salesStatus,
            selectedPricingLabel: props.data.robot.minimumProfitMarginType,
            minimumProfitMargin: props.data.robot.minimumProfitMargin,
            purchasePrice: props.data.robot.purchasePrice,
            salesPrice: props.data.salesPrice,
            lastUpdate: calculateDate(props.data.lastUpdate ? props.data.lastUpdate : '۱ دقیقه پیش'),
        }
        setEditInfo({ ...tmp })
        setIsEdited(false)
    }

    const setAllEditInfo = () => {
        // call to change
        editFunction('editInfo')
        setIsEdited(false)
    }

    const convertDropDownValue = value => {
        let result = '';
        if (value.name) {
            result = value.name
        } else {
            switch (value) {
                case 'minPrice':
                    result = 'قیمت نهایی'
                    break;
                case 'percent':
                    result = 'درصد'
                    break;
                case 'price':
                    result = 'مبلغ'
                    break;
            }
        }
        return result
    }

    const editFunction = async (type) => {
        let data = props.data.robot
        if (type == 'activeRobot') {
            data.salesStatus = editInfo.isRobotActive
        } else {
            data.minimumProfitMarginType = editInfo.selectedPricingLabel.value
            data.minimumProfitMargin = editInfo.minimumProfitMargin
            data.purchasePrice = editInfo.purchasePrice
        }
        data.variantId = props.data._id
        // change SalesPrice
        if (Number(props.data.salesPrice) !== Number(editInfo.salesPrice)) {
            if (Number(editInfo.salesPrice) < Number(props.data.robot.minPrice) || Number(editInfo.salesPrice) > Number(props.data.robot.maxPrice)) {
                props.openToast('قیمت فروش وارد شده در بازه‌ی حداقل و حداکثر قیمت شما نمی‌باشد')
                resetAllEditInfo()
            } else {
                let res = props.SubmitEditSalesPrice({ productId: data.variantId, channelId: props.data.channel._id, price: Number(editInfo.salesPrice) })
                await callEditVariantFunction(data)
            }
        } else {
            await callEditVariantFunction(data)
        }
    }

    const callEditVariantFunction = async (data) => {
        // get Commission
        let commission = await getManyVariant([props.data.productGroup])
        data.DKCommission = commission.data.maxinCommission ? commission.data.maxinCommission : commission.data.minCommission
        // edit Variant ===> update variant
        setIsUpdating(true)
        let res = await props.SubmitEditVariant(data)
        setIsUpdating(false)
    }

    const calculateDate = (dateString) => {
        let result = 0
        let lastUpdate = moment.utc(dateString)
        let current = moment().utc()
        let diff = (current - lastUpdate) / 1000;
        diff /= (60 * 60);
        result = Math.floor(diff) + ' ساعت پیش'

        if (Math.floor(diff) == 0) {
            let duration = moment.duration(current.diff(lastUpdate));
            let minutes = duration.asMinutes();
            result = Math.floor(minutes) + ' دقیقه پیش'
        }
        if (Math.floor(diff) > 24) {
            let duration = moment.duration(current.diff(lastUpdate));
            let days = duration.asDays();
            result = Math.floor(days) + ' روز پیش'
        }
        return result
    }

    const [editInfo, setEditInfo] = useState({
        isRobotActive: props.data.robot.salesStatus,
        selectedPricingLabel: { value: props.data.robot.minimumProfitMarginType, name: '' },
        minimumProfitMargin: props.data.robot.minimumProfitMargin,
        purchasePrice: props.data.robot.purchasePrice,
        salesPrice: props.data.salesPrice ? props.data.salesPrice : '',
        lastUpdate: calculateDate(props.data.lastUpdate ? props.data.lastUpdate : '۱ دقیقه پیش'),
    })

    const calculateLines = text => {
        if (text.length < 88) {
            return text
        } else {
            return text.substr(0, 76) + '...'
        }
    }

    const calculateOthersInBoxName = text => {
        let name = text
        if (text.length > 25) {
            name = name.substr(0, 22) + '...'
        }
        return name
    }

    const saveCodeToClipboard = code => {
        if (code) {
            navigator.clipboard.writeText(code)
            alert('کد مورد نظر شما کپی شد')
        }
    }

    const renderTips = tips => {
        let firstRow = tips[0]
        let remainingRows = tips.slice(1)
        return <div className={style.tipsWrapper}>
            <div className={style.firstRow}>
                <div className={style.firstRowIcon}></div>
                <p className={style.firstRowText}>{toPersianNumber(numberWithCommas(firstRow))}</p>
                {remainingRows.length > 0 && <div className={style.firstRowLink} onClick={() => setMoreTips(!moreTips)}>
                    <p className={style.text}>موارد بیشتر</p>
                    <div className={!moreTips ? style.arrow : style.arrowActive}>c</div>
                </div>}
            </div>
            {remainingRows.length > 0 && moreTips && <ul className={style.restOfTips}>
                {remainingRows.map((row, rowIndex) => <li key={`rowIndex_${rowIndex}`}>{toPersianNumber(numberWithCommas(row))}</li>)}
            </ul>}
        </div>
    }


    if (isUpdating) {
        return <Skeleton type='rectangle' width='100%' height='186px' />
    }
    else {
        return (
            <div className={style.wrapper}>
                <div
                    className={style[backgroundColor()]}>
                    <div className={style.newFlexWrapper}>
                        <div className={`${style.flexItem} ${style.flexItem303}`}>
                            <div className={style.nameStyle}>
                                <Link className={style.name} style={{ textDecoration: "none" }} to={{ pathname: `https://www.digikala.com/product/dkp-${props.data.DKP}` }} target="_blank">
                                    <div className={style.nameWrapper}>
                                        <p
                                            className={style.realName}
                                            data-content={!props.data.newName.split(' | ')[1].includes('گارانتی')
                                                &&
                                                !props.data.newName.split(' | ')[1].includes('تضمین')
                                                ?
                                                '(' + toPersianNumber(props.data.newName.split(' | ')[1]) + ')'
                                                :
                                                ''}
                                            ref={nameRef}
                                        >
                                            {toPersianNumber(props.number)}. {calculateLines(toPersianNumber(props.data.newName))}
                                        </p>
                                    </div>
                                </Link>
                            </div>

                            <div className={style.DKPStyle}>
                                <div className={style.clipboard} onClick={() => saveCodeToClipboard(props.data.DKPC)}>
                                    <p className={style.codeNumber}>DKPC - {toPersianNumber(props.data.DKPC)}</p>
                                    <div className={style.tooltip}>برای کپی کردن کد کلیک کنید</div>
                                </div>
                                <p className={style.DKPSeprator}></p>
                                <div className={style.clipboard} onClick={() => saveCodeToClipboard(props.data.DKP)}>
                                    <p className={style.codeNumber}>DKP - {toPersianNumber(props.data.DKP)}</p>
                                    <div className={style.tooltip}>برای کپی کردن کد کلیک کنید</div>
                                </div>
                                <p className={style.DKPSeprator}></p>
                                <div className={style.clipboard} onClick={() => saveCodeToClipboard(props.data.supplierCode)}>
                                    <p className={style.codeNumber}>{props.data.supplierCode ? toPersianNumber(props.data.supplierCode) : '--'}</p>
                                    {props.data.supplierCode && <div className={style.tooltip}>برای کپی کردن کد کلیک کنید</div>}
                                </div>
                            </div>

                            <div className={style.channelPromotion}>
                                {props.data && props.data.channel && props.hasManyChannels ? <p className={style.channelText}>{props.data.channel.name}{typeof props.data.channel._id != 'undefined' && props.data.channel._id == "66c7067044e53ffa53755c93" ? ' ۲ ' : ''}</p> : <p> </p>}
                                {props.data && props.data.isInPromotion && props.data.channel && props.hasManyChannels ? <p className={style.divider}></p> : <p> </p>}
                                {props.data && props.data.isInPromotion ? <p className={style.promotionText}>پروموشن</p> : <p> </p>}
                            </div>
                        </div>

                        <div className={style.flexItem42}>
                            <div className={style.switchWrapper}>
                                <SwitchButton
                                    value={editInfo.isRobotActive}
                                    tag={'isRobotActive'}
                                    disabled={false}
                                    onclick={toggleActiveRobot}
                                />
                            </div>
                        </div>

                        <div className={style.flexItem112}>
                            <input
                                type='text'
                                value={toPersianNumber(numberWithCommas(editInfo.salesPrice))}
                                className={style.editableSalesPrice}
                                onChange={e => handleEditInfo('salesPrice', e)}>
                            </input>
                            {props.data.otherInByBox && props.data.otherInByBox.price && <div className={style.otherInByBux}>
                                <p>{props.data.otherInByBox && props.data.otherInByBox.price ? toPersianNumber(numberWithCommas(props.data.otherInByBox.price)) : ''}</p>
                                <p>{props.data.otherInByBox && props.data.otherInByBox.name ? '(' + calculateOthersInBoxName(toPersianNumber(numberWithCommas(props.data.otherInByBox.name))) + ')' : ''}</p>
                            </div>}
                        </div>

                        <div className={style.flexItem96}>
                            <div className={style.text}>
                                <p>{props.data.robot && props.data.robot.minPrice ? toPersianNumber(numberWithCommas(parseInt(props.data.robot.minPrice))) : '--'}</p>
                            </div>
                            <div className={style.divider}></div>
                            <div className={style.text}>
                                <p>{props.data.robot && props.data.robot.maxPrice ? toPersianNumber(numberWithCommas(parseInt(props.data.robot.maxPrice))) : '--'}</p>
                            </div>
                        </div>
                        <div className={style.flexItem214}>
                            <div className={style.inputWrapper}>
                                <div className={style.firstInput}>
                                    <EditDropDown
                                        tag='selectedPricingLabel'
                                        label=''
                                        placeHolder={editInfo.selectedPricingLabel ? convertDropDownValue(editInfo.selectedPricingLabel) : 'انتخاب'}
                                        dropdownList={[{ name: 'قیمت نهایی', value: 'minPrice' }, { name: 'درصد', value: 'percent' }, { name: 'مبلغ', value: 'price' }]}
                                        hasSearchBox={false}
                                        hasCheckbox={false}
                                        handleSelect={(tag, item) => handleEditInfo(tag, item)}
                                        deleteSelectedItems={() => deleteAll(null)}
                                        errorMessage=''
                                    />
                                </div>
                                <div className={style.secondInput}>
                                    <EditInput
                                        type="text"
                                        disabled={false}
                                        label=""
                                        placeholder=""
                                        tag="minimumProfitMargin"
                                        value={editInfo.minimumProfitMargin}
                                        error=''
                                        tooltip=''
                                        onchange={(e, tag) => handleEditInfo(e, tag)}
                                        onblur={() => console.log('')}
                                    />
                                </div>

                            </div>
                            <div className={style.inputWrapper}>
                                <div className={style.growFlexItem}>
                                    <EditInput
                                        type="text"
                                        disabled={false}
                                        label=""
                                        placeholder=""
                                        tag="purchasePrice"
                                        value={editInfo.purchasePrice}
                                        error=''
                                        tooltip=''
                                        onchange={(e, tag) => handleEditInfo(e, tag)}
                                        onblur={() => console.log('')}
                                    />
                                </div>
                            </div>

                            <div>
                            </div>
                        </div>
                        <div className={style.flexItem32noMargin}>
                            {/* Check Mark */}
                            {isEdited && <div
                                className={style.editCheckMark}
                                onClick={() => setAllEditInfo()}
                            >
                                <div className={style.editCheckMarkImage}></div>
                            </div>}
                            {/* Cross Mark */}
                            {isEdited && <div
                                className={style.editCrossMark}
                                onClick={() => resetAllEditInfo()}
                            >e</div>}
                        </div>
                        <div
                            className={style.flexItem78}
                            onClick={() => setMoreInfo(!moreInfo)}
                        >
                            {/* More Info Mark */}
                            <p>جزئیات</p>
                            <div className={style.moreInfoArrowBox}>
                                <div className={!moreInfo ? style.moreInfoArrow : style.moreInfoArrowActive}></div>
                            </div>
                        </div>
                    </div>

                    <div className={moreInfo ? style.showInfo : style.hideInfo}>
                        <div className={`${style.moreInfoRow} ${style[`${backgroundColor()}Info`]}`}>
                            <div className={style.col}>
                                <p className={style.label}>قیمت مرجع</p>
                                <p className={style.colValue}>{props.data.resourcePrice ? toPersianNumber(numberWithCommas(props.data.resourcePrice)) : '--'}<span className={style.currency}> ریال </span></p>
                            </div>
                            <div className={style.rowDivider}></div>
                            <div className={style.col}>
                                <p className={style.label}>تعداد رقیب</p>
                                <p className={style.colValue}>{props.data.otherSellerCount ? toPersianNumber(numberWithCommas(props.data.otherSellerCount)) : '--'}</p>
                            </div>
                            <div className={style.rowDivider}></div>
                            <div className={style.col}>
                                <p className={style.label}>موجودی انبار دیجی‌کالا</p>
                                <p className={style.colValue}>{props.data.digikalaStock ? toPersianNumber(numberWithCommas(props.data.digikalaStock)) : '--'}</p>
                            </div>
                            <div className={style.rowDivider}></div>
                            <div className={style.col}>
                                <p className={style.label}>موجودی انبار فروشنده</p>
                                <p className={style.colValue}>{props.data.sellerStock ? toPersianNumber(numberWithCommas(props.data.sellerStock)) : '--'}</p>
                            </div>
                            <div className={style.rowDivider}></div>
                            <div className={style.col}>
                                <p className={style.label}>آخرین به‌روز رسانی</p>
                                <p className={style.colValue}>{props.data && props.data.lastUpdate ? toPersianNumber(editInfo.lastUpdate) : '--'}</p>
                            </div>
                            <div className={style.rowDivider}></div>
                            <div className={style.col}>
                                <p className={style.label}>وضعیت سود</p>
                                <div className={style.rangeSliderValue}>
                                    <RangeSlider
                                        userProfit={editInfo.salesPrice}
                                        minProfit={props.data.robot.minPrice}
                                        maxProfit={props.data.robot.maxPrice}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={style.newFlexWrapper}>
                        <div className={style.buttonsBox}>
                            <button
                                className={style.proEditButton}
                                onClick={() => props.repriceVariant(props.data._id)}
                            >
                                قیمت‌گذاری در لحظه
                            </button>
                            <button
                                className={style.proEditButton}
                                onClick={() => props.openCommentInsights(props.data.DKP, props.data.newName, props.data.channel.name)}
                            >
                                تحلیل دیدگاه‌ها
                            </button>
                        </div>
                        <div className={style.buttonsBox}>
                            <button
                                className={style.proEditButton}
                                onClick={() => props.threeDotHandler(props.data._id)}
                            >
                                تنظیمات پیشرفته
                            </button>
                        </div>
                    </div>
                </div>
                {
                    props.data.errorText && props.data.robot.salesStatus &&
                    <div className={style.errorBox}>
                        <div className={style.textWrapper}>
                            <div className={style.icon}>n</div>
                            <p className={style.text}>{ErrorCodes[props.data.errorText] ? ErrorCodes[props.data.errorText] : toPersianNumber(numberWithCommas(props.data.errorText.replaceAll('.', '')))}</p>
                        </div>
                        {typeof props.data.tips != 'undefined' && props.data.tips.length > 0 && <>
                            <div className={style.tipSeprator}></div>
                            {renderTips(props.data.tips)}
                        </>}
                    </div>
                }
                {
                    !props.data.errorText && typeof props.data.noticeText != 'undefined' && props.data.noticeText != "" &&
                    <div className={style.lowestPriceBox}>
                        <div className={style.textWrapper}>
                            <div className={style.icon}>f</div>
                            <p className={style.text}>{props.data.noticeText.replaceAll('.', '')}</p>
                        </div>
                        {typeof props.data.tips != 'undefined' && props.data.tips.length > 0 && <>
                            <div className={style.tipSeprator}></div>
                            {renderTips(props.data.tips)}
                        </>}
                    </div>
                }
                {
                    props.data.robot.salesStatus && props.data.robot.pricingStrategy != 'lowestPrice' && !props.data.errorText && !props.data.noticeText && typeof props.data.tips != 'undefined' && props.data.tips.length > 0 && <div className={style.lowestPriceBox}>
                        <div className={style.textWrapper}>
                            {renderTips(props.data.tips)}
                        </div>
                    </div>
                }
            </div >
        )
    }
}
export default PricingCard